/**File containing definitions for commonly used strings*/

// item types
export const itemTypes = {
    helpset: "helpset",
    filepub: "filePub",
    shortcut: "shortcut",
    download: "download",
    category: "category",
    dhs: "directHelpset",
  }
  